exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body,html{margin:0;padding:0;min-height:100vh}body{background-color:#111;color:#fff}*,body{font-family:Roboto Condensed,sans-serif}.button{padding:20px 50px;text-align:center;display:inline-block;text-transform:uppercase;font-weight:300;font-size:22px}.button:hover{cursor:pointer}.button--green{background-color:#2ebd59;color:#fff}.intro{display:table;width:inherit;height:inherit;height:100vh;width:100%}.intro__content{display:table-cell;vertical-align:middle}.intro__text{text-align:center;padding:30px 0 0;margin:0 auto;width:100%;max-width:600px}.intro__presented{font-size:16px;text-transform:uppercase;font-weight:300}.intro__title{font-size:36px;font-weight:300;border-bottom:2px solid #fff;border-top:2px solid #fff;margin:30px 0;padding:20px 0}.intro__description{font-size:13px;margin:30px 0 0}.intro svg{margin-top:-72px}.intro svg *{stroke:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2352242c!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 46
// module chunks = 0